export default __webpack_public_path__ + "static/media/SPONSOR-Rotary.a72e6574.svg";